/* Healthy Box — selection des recettes, compteur de box, consigne et abonnement.
   Un seul fichier pour toute la boutique : la grille, la barre et le panier s'y abonnent.

   Abonnement : chaque recette porte son propre plan, lu sur sa fiche produit.
   Il peut donc y avoir un plan par gamme de box sans rien recopier ici. */
(function(){
  'use strict';

  var HB = window.HealthyBox = window.HealthyBox || {};
  var abonnes = [];
  var consigne = null;
  var ajustEnCours = false;
  var plans = {};        /* identifiant produit -> identifiant de plan */
  var planDefaut = null; /* utilise si le produit n'est pas dans la table */

  function nettoyerId(v){
    var s = v === 0 || v ? String(v).replace(/[^0-9]/g, '') : '';
    return s ? s : null;
  }

  function lireParam(nom){
    try { return new URLSearchParams(window.location.search).get(nom); } catch(e){ return null; }
  }

  function ecrireBox(b){
    try { sessionStorage.setItem('hb_box', JSON.stringify(b)); } catch(e){}
    return b;
  }

  function lireBox(){
    var b = {};
    try { b = JSON.parse(sessionStorage.getItem('hb_box') || '{}') || {}; } catch(e){ b = {}; }

    var pers = parseInt(lireParam('pers') || b.pers, 10);
    var plats = parseInt(lireParam('plats') || b.plats, 10);
    var cp = lireParam('cp') || b.cp || null;
    var abo = lireParam('abo');

    if(!isNaN(pers) && pers > 0) b.pers = pers;
    if(!isNaN(plats) && plats > 0) b.plats = plats;
    if(cp) b.cp = cp;
    if(abo !== null) b.abo = (abo === '1' || abo === 'true');

    if(lireParam('pers') || lireParam('plats') || lireParam('cp') || abo !== null){
      ecrireBox(b);
    }
    return b;
  }

  HB.box = lireBox;

  /* Choisit la variante la plus adaptee au nombre de personnes.
     Variantes attendues : "1 personne", "2 personnes", "4 personnes".
     Si aucune ne correspond exactement, on prend un diviseur et on
     multiplie la quantite. */
  HB.choisirVariante = function(variantes, pers){
    if(!variantes || !variantes.length) return null;
    var dispo = variantes.filter(function(v){ return v.dispo !== false; });
    if(!dispo.length) dispo = variantes;

    var avecNb = dispo.map(function(v){
      var m = (v.titre || '').match(/(\d+)/);
      return { id: v.id, titre: v.titre, nb: m ? parseInt(m[1], 10) : null };
    });

    var p = parseInt(pers, 10);
    if(isNaN(p) || p < 1) p = 1;

    var exact = avecNb.filter(function(v){ return v.nb === p; })[0];
    if(exact) return { id: exact.id, quantite: 1, titre: exact.titre };

    var divis = avecNb.filter(function(v){ return v.nb && p % v.nb === 0; })
                      .sort(function(a, b){ return b.nb - a.nb; })[0];
    if(divis) return { id: divis.id, quantite: p / divis.nb, titre: divis.titre };

    var unite = avecNb.filter(function(v){ return v.nb === 1; })[0] || avecNb[0];
    return { id: unite.id, quantite: unite.nb ? Math.ceil(p / unite.nb) : p, titre: unite.titre };
  };

  HB.panier = function(){
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); });
  };

  /* Une recette, et pas les contenants ni les frais : le type de produit
     doit contenir le mot recette. */
  function estRecette(item){
    return ((item.product_type || '').toLowerCase().indexOf('recette') !== -1);
  }

  HB.estRecette = estRecette;

  /* ---- Abonnement -------------------------------------------------- */

  /* Table produit -> plan, posee par la page qui affiche les recettes.
     Permet un plan different par gamme de box. */
  HB.reglerPlans = function(table){
    plans = {};
    if(!table) return;
    Object.keys(table).forEach(function(k){
      var id = nettoyerId(table[k]);
      if(id) plans[String(k)] = id;
    });
  };

  /* Plan de repli quand un produit n'est pas dans la table. */
  HB.reglerPlan = function(id){ planDefaut = nettoyerId(id); };

  HB.planDisponible = function(){
    return !!planDefaut || Object.keys(plans).length > 0;
  };

  /* Le plan a appliquer a ce produit : null si le client a choisi
     l'achat unique, ou si aucun plan n'est rattache au produit. */
  HB.planPour = function(productId){
    if(!lireBox().abo) return null;
    return plans[String(productId)] || planDefaut || null;
  };

  HB.estAbonne = function(){ return !!lireBox().abo; };

  /* Memorise le choix et realigne les lignes deja au panier. */
  HB.definirAbo = function(oui){
    var b = lireBox();
    b.abo = !!oui;
    ecrireBox(b);
    return HB.appliquerPlan();
  };

  function planDeLigne(item){
    if(item && item.selling_plan_allocation && item.selling_plan_allocation.selling_plan){
      return String(item.selling_plan_allocation.selling_plan.id);
    }
    return null;
  }

  HB.planDeLigne = planDeLigne;

  /* ---- Melange de box ---------------------------------------------- */

  /* Le plan deja engage par les recettes du panier, s'il y en a un.
     Avec un plan par gamme, c'est la box en cours de composition. */
  HB.planEngage = function(panier){
    var items = (panier && panier.items) || [];
    for(var i = 0; i < items.length; i++){
      if(!estRecette(items[i])) continue;
      var p = planDeLigne(items[i]);
      if(p) return p;
    }
    return null;
  };

  /* Vrai si ajouter ce produit melangerait deux box dans le meme panier.
     Shopify cree un contrat par plan : un panier a cheval sur deux plans
     donne deux abonnements, donc deux prelevements. On l'empeche.
     En achat unique il n'y a pas de plan, donc pas de conflit. */
  HB.conflitDeBox = function(productId, panier){
    if(!lireBox().abo) return false;
    var vise = plans[String(productId)] || planDefaut || null;
    if(!vise) return false;
    var engage = HB.planEngage(panier);
    if(!engage) return false;
    return engage !== vise;
  };

  /* Le plan que cette ligne devrait porter. On ne touche pas a une ligne
     dont on ne connait pas le plan : mieux vaut ne rien faire que de la
     basculer sur le plan d'une autre gamme. */
  function planAttendu(item){
    if(!lireBox().abo) return null;
    return plans[String(item.product_id)] || planDefaut || null;
  }

  function aAligner(item){
    var actuel = planDeLigne(item);
    if(!lireBox().abo) return actuel !== null;   /* retirer tout plan */
    var vise = planAttendu(item);
    if(!vise) return false;                      /* plan inconnu : on laisse */
    return actuel !== vise;
  }

  /* Aligne une recette a la fois : la cle change apres chaque
     modification, donc on relit le panier. Le compteur evite toute
     boucle si le serveur refuse le changement. */
  function alignerUne(reste){
    if(reste <= 0) return HB.panier();

    return HB.panier().then(function(c){
      var cible = null;
      var items = c.items || [];
      for(var i = 0; i < items.length; i++){
        if(!estRecette(items[i])) continue;
        if(aAligner(items[i])){ cible = items[i]; break; }
      }
      if(!cible) return c;

      var vise = planAttendu(cible);
      var corps = { id: cible.key, quantity: cible.quantity, selling_plan: vise ? vise : '' };

      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(corps)
      }).then(function(r){ return r.json(); })
        .then(function(){ return alignerUne(reste - 1); })
        .catch(function(){ return c; });
    });
  }

  HB.appliquerPlan = function(){
    return alignerUne(24).then(function(){ return HB.prevenir(); });
  };

  /* ---- Panier ------------------------------------------------------ */

  /* plan vaut null pour un achat unique. Les contenants passent toujours
     par la sans plan : ils se paient une seule fois. */
  HB.ajouter = function(variantId, quantite, plan){
    var ligne = { id: variantId, quantity: quantite || 1 };
    if(plan) ligne.selling_plan = String(plan);

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [ligne] })
    }).then(function(r){ return r.json(); }).then(function(d){ HB.prevenir(); return d; });
  };

  /* Ajoute une recette avec le plan de son propre produit. */
  HB.ajouterRecette = function(variantId, quantite, productId){
    return HB.ajouter(variantId, quantite, HB.planPour(productId));
  };

  HB.retirer = function(cle){
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: cle, quantity: 0 })
    }).then(function(r){ return r.json(); }).then(function(d){ HB.prevenir(); return d; });
  };

  /* Vide toutes les recettes du panier. Sert quand le client veut
     changer de box en cours de composition. */
  HB.viderRecettes = function(){
    return HB.panier().then(function(c){
      var cles = (c.items || []).filter(estRecette).map(function(i){ return i.key; });
      if(!cles.length) return c;
      var maj = {};
      cles.forEach(function(k){ maj[k] = 0; });
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: maj })
      }).then(function(r){ return r.json(); }).then(function(d){ HB.prevenir(); return d; });
    });
  };

  /* Contenants reutilisables : une seule ligne, ajoutee des la premiere
     recette, retiree si le panier se vide. active vaut false quand le
     client a deja commande : il les a deja payes. */
  HB.reglerConsigne = function(cfg){
    consigne = cfg && cfg.id ? cfg : null;
    HB.prevenir();
  };

  function ajusterConsigne(panier){
    if(!consigne || ajustEnCours) return;

    var items = panier.items || [];
    var recettes = items.filter(estRecette).length;
    var ligne = null;
    for(var i = 0; i < items.length; i++){
      if(items[i].variant_id === consigne.id || items[i].id === consigne.id){ ligne = items[i]; break; }
    }

    function fin(){ ajustEnCours = false; }

    if(recettes > 0 && !ligne && consigne.active){
      ajustEnCours = true;
      HB.ajouter(consigne.id, 1).then(fin, fin);
    } else if(ligne && (recettes === 0 || !consigne.active)){
      ajustEnCours = true;
      HB.retirer(ligne.key).then(fin, fin);
    }
  }

  HB.surChangement = function(fn){ abonnes.push(fn); };

  HB.prevenir = function(){
    return HB.panier().then(function(c){
      abonnes.forEach(function(fn){ try { fn(c); } catch(e){} });
      try { document.dispatchEvent(new CustomEvent('hb:panier', { detail: c })); } catch(e){}
      ajusterConsigne(c);
      return c;
    });
  };

  document.addEventListener('DOMContentLoaded', function(){ HB.prevenir(); });
  if(document.readyState !== 'loading'){ HB.prevenir(); }
})();
